export default __webpack_public_path__ + "static/media/texture.8d6f8d46.svg";